import { ConstData } from "./helpers";

export const GENDERS: ConstData[] = [
  { title: "Male", value: "male" },
  { title: "Female", value: "female" },
  { title: "Other", value: "other" },
]



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/constants/genders.ts